import { render, staticRenderFns } from "./NaplataDialogSettings.vue?vue&type=template&id=740f632b"
import script from "./NaplataDialogSettings.vue?vue&type=script&lang=js"
export * from "./NaplataDialogSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports